import React from "react";

interface VitalsCardProps {
  title: string;
  label: string;
  temperature: number;
  unit: string;
}

const EventEHRVitalsCard = ({
  title,
  label,
  temperature,
  unit,
}: VitalsCardProps) => {
  // Define styles based on the label value

  const getLabelStyles = (label: string) => {
    switch (label.toLowerCase()) {
      case "low":
        return {
          bgColor: "bg-[#FFFBEA]",
          textColor: "text-[#B68B00]",
          borderColor: "border-[#FFD700]",
        };
      case "high":
        return {
          bgColor: "bg-[#FFF2F2]",
          textColor: "text-[#A10000]",
          borderColor: "border-[#FF0000]",
        };
      case "moderate":
        return {
          bgColor: "bg-[#F4FFF2]",
          textColor: "text-[#016A1C]",
          borderColor: "border-[#42D75B]",
        };
      case "normal":
        return {
          bgColor: "bg-[#E9F7EF]",
          textColor: "text-[#1E8449]",
          borderColor: "border-[#28B463]",
        };
      case "elevated":
        return {
          bgColor: "bg-[#FFF8E1]",
          textColor: "text-[#FF9800]",
          borderColor: "border-[#FFC107]",
        };
      case "stage 1 hypertension":
        return {
          bgColor: "bg-[#FDEBD0]",
          textColor: "text-[#CA6F1E]",
          borderColor: "border-[#E67E22]",
        };
      case "stage 2 hypertension":
        return {
          bgColor: "bg-[#FADBD8]",
          textColor: "text-[#A93226]",
          borderColor: "border-[#CB4335]",
        };
      case "hypertension crisis":
        return {
          bgColor: "bg-[#F5B7B1]",
          textColor: "text-[#78281F]",
          borderColor: "border-[#943126]",
        };
      default:
        return {
          bgColor: "bg-white",
          textColor: "text-black",
          borderColor: "border-gray-300",
        };
    }
  };

  const labelStyles = getLabelStyles(label);

  return (
    <>
      <div className="w-[268px] border-[0.5px] bg-white border-[#979797] rounded-[8px] pt-3 pr-4 pb-3 pl-4 gap-[8px] flex flex-col">
        <div className="gap-[4px] flex justify-between items-center">
          <span className="font-medium text-xs leading-[14.4px] text-[#727272]">
            {title}
          </span>
          <span
            className={`rounded-[16px] border-[0.5px] pt-1 pr-2 pb-1 pl-2 text-[10px] leading-[10px] text-center tracking-[0.2%] font-medium ${labelStyles.bgColor} ${labelStyles.textColor} ${labelStyles.borderColor}`}
          >
            {label}
          </span>
        </div>
        <div className="space-x-1 flex justify-start items-center gap-0">
          <div className=" font-semibold text-lg text-[#565656] leading-[21.6px]">
            {temperature}
          </div>
          <div className="font-medium text-xs text-[#727272] leading-[14.4px]">
            {unit}
          </div>
        </div>
      </div>
    </>
  );
};

export default EventEHRVitalsCard;
